import React from 'react';
import { Link } from 'react-router-dom';
import AboutImg from '../../components/assets/yapImg/about/01.jpg';

const milestones = [
    { year: '2015', title: 'Organization', text: 'YAP began with a focused mission to close education and skill gaps for youth.' },
    { year: '2017', title: 'Expansion', text: 'Operations scaled across Sindh, Punjab, Balochistan, Gilgit and KPK to support more communities.' },
    { year: '2020', title: 'Digital Shift', text: 'Hybrid and online learning paths helped us keep momentum in uncertain times.' },
    { year: '2024', title: 'Growing Impact', text: '50,000+ beneficiaries served with programs in education, employability, and leadership.' },
];

const About = () => {
    return (
        <section className="bg-[linear-gradient(180deg,_#f8fafc_0%,_#ecfdf5_45%,_#ffffff_100%)] py-16">
            <div className="mx-auto grid max-w-7xl items-start gap-10 px-4 lg:grid-cols-2 lg:px-8">
                <div className="relative overflow-hidden rounded-3xl border border-emerald-100 bg-white shadow-xl">
                    <img src={AboutImg} alt="YAP community activities" className="h-full min-h-[340px] w-full object-cover" />
                    <div className="absolute bottom-4 left-4 rounded-xl bg-black/65 px-4 py-3 text-white backdrop-blur-sm">
                        <p className="text-xs uppercase tracking-[0.2em] text-emerald-200">Youth Association of Pakistan</p>
                        <p className="text-xl font-bold">Empowering Communities Through Youth</p>
                    </div>
                </div>

                <div>
                    <p className="text-sm font-semibold uppercase tracking-[0.24em] text-emerald-700">About YAP</p>
                    <h2 className="mt-3 text-4xl font-black leading-tight text-slate-900">Building futures with practical action, not promises.</h2>
                    <p className="mt-4 text-lg text-slate-600">
                        We design programs that move youth from potential to progress through education access, skill building, and local leadership.
                    </p>
                    <div className="mt-6 grid gap-4 sm:grid-cols-2">
                        <div className="rounded-xl border border-slate-200 bg-white p-4">
                            <p className="text-3xl font-black text-emerald-600">50K+</p>
                            <p className="text-sm font-semibold text-slate-600">Direct Beneficiaries</p>
                        </div>
                        <div className="rounded-xl border border-slate-200 bg-white p-4">
                            <p className="text-3xl font-black text-emerald-600">5</p>
                            <p className="text-sm font-semibold text-slate-600">Provinces Reached</p>
                        </div>
                    </div>
                    <Link to="/about" className="mt-7 inline-block rounded-full bg-slate-900 px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition hover:bg-emerald-700">
                        Explore Full Story
                    </Link>
            <div className="mx-auto mt-12 grid max-w-7xl gap-4 px-4 sm:grid-cols-2 lg:grid-cols-2 lg:px-8">
                {milestones.map((item) => (
                    <article key={item.year} className="rounded-2xl border border-emerald-100 bg-white p-5 shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
                        <div className="inline-flex rounded-full bg-emerald-100 px-3 py-1 text-sm font-bold text-emerald-700">{item.year}</div>
                        <h3 className="mt-3 text-lg font-bold text-slate-800">{item.title}</h3>
                        <p className="mt-2 text-sm text-slate-600">{item.text}</p>
                    </article>
                ))}
            </div>
                </div>
            </div>

        </section>
    );
};

export default About;
